<template>
  <div>
    <div class="autorization-table-card">
      <Loading type="line" :center="false" v-show="loading"/>

      <div v-if="!loading && !items.length" class="autorization-table-empty">
        Nenhum registro encontrado
      </div>

      <section v-if="items.length" class="autorization-table-topbar">
        <div class="autorization-table-topbar-left">
          <b-form-checkbox v-model="selectAll"/>
          <p class="ml-2">Selecionar tudo</p>
        </div>
        <div class="autorization-table-topbar-right">
          <TotalRecordsBadge :total="totalRecords"/>
        </div>
      </section>

      <section v-if="items.length" class="autorization-table-header">
        <div class="autorization-table-header-left">Beneficiário</div>
        <div>Vencimento</div>
        <div>Usuário</div>
        <div class="text-center">Valor</div>
        <div class="autorization-table-header-status">Status</div>
      </section>

      <AutorizationRow
          v-for="item in items"
          :key="item.id"
          :item="item"
          @edit="onEdit"
      />

      <Pagination :key="currentPage" :totalRecords="totalRecords"/>
    </div>

    <BottomActionsBar :selected="selected" @close="closeSelectedActions">
      <div class="autorization-table-actions">
        <ActionsSelected :selected="selected" :actions="actions"/>
      </div>
    </BottomActionsBar>

    <Modal title="Despesa" :width="850" :height="250" v-show="showModal('expenseCreateUpdate')">
      <ExpenseCreateUpdate :value="selectedExpense" @saved="onExpenseSaved"/>
    </Modal>

    <Modal title="Equipe" :width="850" :height="450" v-show="showModal('teamUpdateAutorization')">
      <TeamUpdate :cardId="selectedTeamGenericId"/>
    </Modal>
  </div>
</template>

<script>
import Pagination from "@/ui/shared/Pagination.vue";
import Loading from "@/ui/shared/Loading.vue";
import Modal from "@/ui/forms/Modal";
import BottomActionsBar from "@/ui/layout/BottomActionsBar.vue";
import ActionsSelected from "@/ui/shared/actions/ActionsSelected.vue";
import AutorizationRow from "./AutorizationRow.vue";
import AutorizationReject from "./AutorizationReject.vue";
import ExpenseCreateUpdate from "../../../shared/expense/components/ExpenseCreateUpdate.vue";
import TeamUpdate from "../../../shared/team/components/TeamUpdate.vue";
import AutorizationService from "../../services/autorization.service";
import TotalRecordsBadge from "@/ui/layout/TotalRecordsBadge.vue";

import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "AutorizationTable",
  components: {
    Pagination,
    Loading,
    Modal,
    BottomActionsBar,
    ActionsSelected,
    AutorizationRow,
    ExpenseCreateUpdate,
    TeamUpdate,
    TotalRecordsBadge,
  },
  props: {
    items: {type: Array, default: () => []},
    totalRecords: {type: Number, default: 0},
    loading: {type: Boolean, default: false},
    currentPage: {type: Number, default: 1},
  },
  data() {
    return {
      selectedExpense: null,
      selectedTeam: null,
      actions: [
        {
          type: "component",
          description: "Autorizar",
          tooltip: "Autorizar",
          url: AutorizationService.urlChangeStatus,
          method: "put",
          classIcon: "fa-solid fa-check",
          backgroundColor: "var(--color-success)",
          payload: {any: "accept"},
        },
        {
          type: "component",
          description: "Reprovar",
          tooltip: "Reprovar",
          url: AutorizationService.urlChangeStatus,
          method: "put",
          classIcon: "fa-solid fa-ban",
          backgroundColor: "var(--color-danger)",
          preProcessComponent: AutorizationReject,
          preProcessModalTitle: "Motivo da Reprovação",
          payload: {any: "reject"},
        },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("generic", ["selected", "executedSearch", "clearedSearch", "search", "paginations"]),
    selectAll: {
      get() {
        return (
            this.items.length > 0 &&
            this.items.every((item) => this.selected.includes(item.id))
        );
      },
      set(value) {
        this.addSelected(value ? this.items.map((i) => i.id) : []);
      },
    },
    selectedTeamGenericId() {
      return (this.selectedTeam && this.selectedTeam.genericId) || "";
    },
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading", "addSelected", "addEvent"]),
    onEdit(item) {
      if (this.isTeam(item)) {
        this.editTeam(item);
        return;
      }
      this.editExpense(item);
    },
    isTeam(item) {
      return String(item.sourceType || "").toLowerCase() === "team";
    },
    editExpense(item) {
      this.selectedExpense = item;
      this.openModal("expenseCreateUpdate");
    },
    editTeam(item) {
      this.selectedTeam = item;
      this.openModal("teamUpdateAutorization");
      this.addEvent({name: "updateCardTeam", data: item});
    },
    onExpenseSaved({closeOnSave}) {
      if (closeOnSave) this.hideModal();
      this.$emit("reload");
    },
    closeSelectedActions() {
      this.addSelected([]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "postApi" || event.name === "putApi" || event.name === "deleteAllApi" || event.name === "actionsUpdated") {
          this.$emit("reload");
        }
        if (event.name === "page-click") {
          this.$emit("page-change", event.data);
        }
        if (event.name === "reloadCardTeam") {
          this.hideModal();
          this.$emit("reload");
        }
      },
      deep: true,
    },
    executedSearch() {
      if (!this.search.content) {
        this.$emit("clear-search");
        this.removeLoading(["btnSearch"]);
        return;
      }
      this.$emit("set-search", {
        search: this.search.content,
        filter: this.search.filter?.id || "contains",
      });
    },
    clearedSearch() {
      if (!this.search.content) {
        this.removeLoading(["btnClean"]);
        return;
      }
      this.$emit("clear-search");
    },
    "paginations.totalPerPage"(val) {
      this.$emit("set-total-per-page", val);
    },
  },
};
</script>

<style scoped>
.autorization-table-card {
  border: 1px solid var(--border-color);
  background-color: var(--bg-base);
  border-radius: 10px;
  padding: 10px;
  box-shadow: var(--shadow-sm);
}

.autorization-table-empty {
  padding: 24px;
  text-align: center;
  color: var(--text-muted);
  font-size: 14px;
}

.autorization-table-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: var(--bg-base);
  border-bottom: 1px solid var(--border-subtle);
}

.autorization-table-topbar-left,
.autorization-table-topbar-right {
  display: flex;
  align-items: center;
}

.autorization-table-topbar-right {
  justify-content: flex-end;
  gap: 8px;
}


.autorization-table-header {
  display: grid;
  grid-template-columns: 1fr 130px 130px 130px 130px;
  gap: 12px;
  padding: 8px 16px;
  background: var(--bg-elevated);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.autorization-table-header-left {
  padding-left: 44px;
}

.autorization-table-header-status {
  text-align: center;
  padding-right: 16px;
}

.autorization-table-actions {
  display: flex;
  gap: 8px;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}
</style>
